/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomTxCardFieldDefinitionsList/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Item from './Item/index'
import React from 'react'
import TysiaListColumn from 'DesignSystem/TysiaList/TysiaListColumn/index'
import TysiaListHeader from 'DesignSystem/TysiaList/TysiaListHeader/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomTxCardFieldDefinitionsList({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList"
  
}) {
let txCardFieldDefinitionsValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definitions',
})
  return (<React.Fragment
>
<TysiaListHeader
  viewPath={`${viewPath}/TysiaListHeader`}
>
{childProps => (
<React.Fragment>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Name"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Short Name"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Type"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Order"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Alert"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Hide for future"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Multi value"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Tracked"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Mandatory"
/>
)}
</TysiaListColumn>
<TysiaListColumn
{...childProps}
  viewPath={`${viewPath}/TysiaListColumn`}
/>
</React.Fragment>
)}
</TysiaListHeader>
<div
  data-testid="DataVaxiomTxCardFieldDefinitionsList.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(txCardFieldDefinitionsValueData) && txCardFieldDefinitionsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tx_card_field_definition"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Item(${item?.id ?? item?._id ?? index})`}
      >
<Item
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Item(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }